export default function () {
    this.loadEvent()
}